// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t2Ern","right":"styles_right__2bOL-"};